import {LitElement, html} from 'lit';
import {DataManagementService} from '../../service/datamanagement/dataManagementService.js';
import {Service} from '../../service/service.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {BaseComponent} from '../basecomponent.js';


/* global customElements */
class DataTransformRuleSetGrid extends BaseComponent {
	
	static get properties() {
		return {
		};
	}
	
	constructor() {
		super();
	
		var ruleSetGrid = this;
		setTimeout(function(){
			ruleSetGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var ruleSetGrid = this;
		
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'vaadin-button',
					itemid: 'refresh',
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:refresh', ' Refresh')
					], 
					listeners: {
						click: function() {
							actionRefresh();
						}
					}
				},
				{
					tag: 'span',
					innerHTML: '|'
				},
				{
					tag: 'dl-action-button',
					itemid: 'add',
					theme: 'primary',
					'class': 'spacer-toolbar-item',					
					permissions: ['DATA_TRANSFORM_RULESET_MANAGEMENT:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:plus', ' Add')						
					],
					listeners: {
						click: function() {
							actionAddEdit();
						}
					}					
				},
				{
					tag: 'dl-action-button',
					itemid: 'edit',
					'class': 'spacer-toolbar-item',
					disabled: true,	
					permissions: ['DATA_TRANSFORM_RULESET_MANAGEMENT:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:edit', ' Edit')						
					],
					listeners: {
						click: function() {
							actionAddEdit(grid.selectedItems[0]);
						}
					}					
				},
				{
					tag: 'dl-action-button',						
					theme: 'error primary',
					itemid: 'delete',
					disabled: true,
					'class': 'spacer-toolbar-item',
					style: 'float: right;',
					permissions: ['DATA_TRANSFORM_RULESET_MANAGEMENT:DELETE'],
					children:[
						ElementUtil.makeIcon('vaadin:trash', ' Delete')
					],
					listeners: {
						click: function() {
							actionDelete(grid.selectedItems[0]);
						}
					}
				}									
			]
		});		
			
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',			
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true
			},			
			children: [	
				{						
					path: 'dataTransformRuleSetId',
					header: 'Config Id',
					width: '7em'
				},
				{						
					path: 'name',
					header: 'Config Name',
					width: '7em'
				},
				{						
					path: 'dataType',
					header: 'Data Type',
					width: '7em'
				},
				{						
					path: 'fieldRules',
					header: 'Field Rules',
					width: '7em',
					renderer: function(root, column, rowData) {
						var count = (rowData.item.fieldRules && rowData.item.fieldRules.length) ? rowData.item.fieldRules.length : 0;
						root.innerHTML = count + ' field(s)';
					}
				},
				{						
					path: 'activeStatus',
					header: 'Active Status',
					'text-align': 'center',
					width: '7em'
				},
				{						
					path: 'updateDts',
					header: 'Update Date',
					width: '7em',					
					renderer: function(root, column, rowData) {
						var date = TimeUtil.parseDate(rowData.item.updateDts);						
						root.innerHTML = TimeUtil.formatDateStandard(date);						
					}
				},								
				{						
					path: 'updateUser',
					header: 'Update User',
					width: '7em'
				}
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;					
					grid.selectedItems = item ? [item] : [];
					if (grid.selectedItems.length > 0) {
						ElementUtil.query(toolbar, 'edit').disabled = false;
						ElementUtil.query(toolbar, 'delete').disabled = false;						
					} else {
						ElementUtil.query(toolbar, 'edit').disabled = true;
						ElementUtil.query(toolbar, 'delete').disabled = true;
					}
				}
			}
		});	
		
		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbar,
				grid
			]
		});		
		ruleSetGrid.append(flexLayout);		
			
		var actionRefresh = function() {	
			var loadMask = grid.showLoading();
			DataManagementService.getDataTransformRuleSetService().getDataTransformRuleSets().then(function(data){
				loadMask.remove();
				
				grid.activeItem = null;
				grid.items = data;	
			});			
		};
		actionRefresh();
				
		var actionAddEdit = function(record) {
			var fieldRules = (record && record.fieldRules) ? record.fieldRules.slice() : [];
			var availableFields = [];

			var addEditWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: record ? 'Edit' : 'Add',
				icon: 'vaadin:edit',				
				width: .85,
				height: 620,
				listeners: {
					ready: function() {						
						addEditWin.show();

						var loadFields = function(dataType, clearSelection) {
							if (clearSelection) {
								availableFields = [];
							}
							if (!dataType) {
								return Promise.resolve();
							}
							return DataManagementService.getDataTransformRuleSetService().getFieldDefinitions(dataType).then(function(definition) {
								availableFields = (definition && definition.dataField) ? definition.dataField : [];
								availableFields.sort(function(a, b) {
									return (a.name || '').localeCompare(b.name || '');
								});
							});
						};

						var fieldRulesGrid;
						var actionRefreshFieldRules = function() {
							fieldRules.sort(function(a, b) {
								return (a.orderId || 0) - (b.orderId || 0);
							});
							fieldRulesGrid.items = fieldRules.slice();
						};

						var actionAddEditFieldRule = function(fieldRuleRecord) {
							var transforms = (fieldRuleRecord && fieldRuleRecord.transforms) ? fieldRuleRecord.transforms.slice() : [];
							var fieldRuleWin = ElementUtil.create({
								tag: 'dl-dialog',
								title: (fieldRuleRecord ? 'Edit' : 'Add') + ' Field Rule',
								icon: 'vaadin:edit',
								width: .75,
								height: 480,
								listeners: {
									ready: function() {
										fieldRuleWin.show();

										var transformGrid;
										var actionRefreshTransforms = function() {
											transforms.sort(function(a, b) {
												return (a.orderId || 0) - (b.orderId || 0);
											});
											transformGrid.items = transforms.slice();
										};

										var actionAddEditTransform = function(transformRecord) {
											var transformWin = ElementUtil.create({
												tag: 'dl-dialog',
												title: (transformRecord ? 'Edit' : 'Add') + ' Transform',
												icon: 'vaadin:edit',
												width: .65,
												height: 300,
												listeners: {
													ready: function() {
														transformWin.show();
														var transformFormPanel = ElementUtil.create({
															tag: 'dl-form-panel',
															children: [
																{
																	tag: 'vaadin-form-layout',
																	children: [
																		{
																			tag: 'vaadin-combo-box',
																			itemid: 'transformCB',
																			name: 'transform',
																			label: 'Transform',
																			'item-value-path': 'transformId',
																			'item-label-path': 'description',
																			required: true,
																			postinit: function (combo) {
																				DataManagementService.getDataTransformRuleSetService().getTransforms().then(function(transformList) {
																					transformList.sort(function (a, b) {
																						return a.description.localeCompare(b.description);
																					});
																					combo.items = transformList;
																				});
																			},
																			listeners: {
																				'selected-item-changed': function() {
																					var item = ElementUtil.query(transformFormPanel, 'transformCB').selectedItem;
																					var optionField = ElementUtil.query(transformFormPanel, 'transformOption');
																					if (item && item.requiresOption) {
																						optionField.disabled = false;
																						optionField.required = true;
																						optionField.helperText = item.optionHelp || item.description || '';
																					} else {
																						optionField.disabled = true;
																						optionField.required = false;
																						optionField.helperText = '';
																					}
																				}
																			},
																			placeHolder: 'Select'
																		},
																		{
																			tag: 'vaadin-number-field',
																			name: 'orderId',
																			label: 'Order Id',
																			required: true,
																			minValue: -999999,
																			maxValue: 999999
																		},
																		{
																			tag: 'vaadin-text-field',
																			itemid: 'transformOption',
																			disabled: true,
																			name: 'transformOption',
																			label: 'Option',
																			maxLength: 255
																		},
																		{
																			tag: 'hr',
																			colspan: 2
																		},
																		{
																			tag: 'div',
																			style: 'text-align: center;',
																			colspan: 2,
																			defaults: {
																				tag: 'vaadin-button'
																			},
																			children: [
																				{
																					theme: 'primary',
																					children: [
																						ElementUtil.makeIcon('vaadin:database', ' Save')
																					],
																					listeners: {
																						click: function() {
																							transformFormPanel.submitForm({
																								actualCall: function(data) {
																									return Promise.resolve(data);
																								},
																								success: function(data) {
																									if (transformRecord) {
																										transformRecord.transform = data.transform;
																										transformRecord.orderId = data.orderId;
																										transformRecord.transformOption = data.transformOption;
																									} else {
																										transforms.push(data);
																									}
																									actionRefreshTransforms();
																									transformWin.close();
																								}
																							});
																						}
																					}
																				},
																				{
																					theme: 'tertiary',
																					innerHTML: 'Cancel',
																					style: 'margin-left: 10px;',
																					listeners: {
																						click: function() {
																							transformWin.close();
																						}
																					}
																				}
																			]
																		}
																	]
																}
															]
														});
														transformWin.addToContentElement(transformFormPanel);
														if (transformRecord) {
															transformFormPanel.load(transformRecord);
														} else {
															transformFormPanel.load({
																orderId: transforms.length + 1
															});
														}
													}
												}
											});
										};

										var fieldRuleForm = ElementUtil.create({
											tag: 'dl-form-panel',
											children: [
												{
													tag: 'vaadin-form-layout',
													children: [
														{
															tag: 'vaadin-combo-box',
															name: 'dataField',
															label: 'Data Field',
															required: true,
															'item-value-path': 'fieldPath',
															'item-label-path': 'name',
															postinit: function (combo) {
																combo.items = availableFields;
															},
															placeHolder: 'Select'
														},
														{
															tag: 'vaadin-number-field',
															name: 'orderId',
															label: 'Order Id',
															required: true,
															minValue: -999999,
															maxValue: 999999
														},
														{
															tag: 'dl-section-title',
															title: 'Transforms',
															colspan: 2
														},
														{
															tag: 'dl-toolbar',
															colspan: 2,
															theme: 'spacing',
															children: [
																{
																	tag: 'vaadin-button',
																	theme: 'primary',
																	children: [
																		ElementUtil.makeIcon('vaadin:plus', ' Add')
																	],
																	listeners: {
																		click: function() {
																			actionAddEditTransform();
																		}
																	}
																},
																{
																	tag: 'vaadin-button',
																	itemid: 'editTransform',
																	'class': 'spacer-toolbar-item',	
																	disabled: true,
																	children: [
																		ElementUtil.makeIcon('vaadin:edit', ' Edit')
																	],
																	listeners: {
																		click: function() {
																			actionAddEditTransform(transformGrid.selectedItems[0]);
																		}
																	}
																},
																{
																	tag: 'vaadin-button',
																	itemid: 'removeTransform',
																	theme: 'error primary',
																	disabled: true,
																	style: 'float: right;',
																	children: [
																		ElementUtil.makeIcon('vaadin:trash', ' Remove')
																	],
																	listeners: {
																		click: function() {
																			var remaining = [];
																			transforms.forEach(function(item) {
																				if (item !== transformGrid.selectedItems[0]) {
																					remaining.push(item);
																				}
																			});
																			transforms = remaining;
																			actionRefreshTransforms();
																		}
																	}
																}
															]
														},
														{
															tag: 'vaadin-grid',
															itemid: 'transformGrid',
															colspan: 2,
															theme: 'row-stripes column-borders',
															style: 'height: 180px;',
															defaults: {
																tag: 'vaadin-grid-sort-column',
																resizable: true
															},
															children: [
																{ path: 'orderId', header: 'Order', width: '5em' },
																{ path: 'transform', header: 'Transform', width: '9em' },
																{ path: 'transformOption', header: 'Option', width: '9em' }
															],
															postinit: function(gridEl) {
																transformGrid = gridEl;
																actionRefreshTransforms();
															},
															listeners: {
																'active-item-changed': function(event) {
																	const item = event.detail.value;
																	transformGrid.selectedItems = item ? [item] : [];
																	var hasSelection = transformGrid.selectedItems.length > 0;
																	ElementUtil.query(fieldRuleForm, 'editTransform').disabled = !hasSelection;
																	ElementUtil.query(fieldRuleForm, 'removeTransform').disabled = !hasSelection;
																}
															}
														},
														{
															tag: 'hr',
															colspan: 2
														},
														{
															tag: 'div',
															style: 'text-align: center;',
															colspan: 2,
															defaults: {
																tag: 'vaadin-button'
															},
															children: [
																{
																	theme: 'primary',
																	children: [
																		ElementUtil.makeIcon('vaadin:database', ' Save')
																	],
																	listeners: {
																		click: function() {
																			fieldRuleForm.submitForm({
																				preSubmit: function(data) {
																					data.transforms = transforms;
																					return data;
																				},
																				actualCall: function(data) {
																					return Promise.resolve(data);
																				},
																				success: function(data) {
																					if (fieldRuleRecord) {
																						fieldRuleRecord.dataField = data.dataField;
																						fieldRuleRecord.orderId = data.orderId;
																						fieldRuleRecord.transforms = data.transforms;
																					} else {
																						fieldRules.push(data);
																					}
																					actionRefreshFieldRules();
																					fieldRuleWin.close();
																				}
																			});
																		}
																	}
																},
																{
																	theme: 'tertiary',
																	innerHTML: 'Cancel',
																	style: 'margin-left: 10px;',
																	listeners: {
																		click: function() {
																			fieldRuleWin.close();
																		}
																	}
																}
															]
														}
													]
												}
											]
										});
										fieldRuleWin.addToContentElement(fieldRuleForm);
										if (fieldRuleRecord) {
											fieldRuleForm.load(fieldRuleRecord);
										} else {
											fieldRuleForm.load({
												orderId: fieldRules.length + 1,
												transforms: []
											});
										}
									}
								}
							});
						};

						var formPanel = ElementUtil.create({
							tag: 'dl-form-panel',
							itemid: 'form',
							children: [
								{
									tag: 'vaadin-form-layout',										
									children: [
										{
											tag: 'vaadin-text-field',										
											name: 'name',
											label: 'Name',
											required: true,
											maxLength: 120											
										},
										{
											tag: 'vaadin-combo-box',
											itemid: 'dataTypeCB',
											name: 'dataType',
											label: 'Data Type',
											required: true,
											'item-value-path': 'code',
											'item-label-path': 'description',
											postinit: function (combo) {
												Service.getLookupService().getLookupValues('DataType').then(function (data) {
													var mappable = [];
													data.forEach(function(item) {
														if (item.mappable) {
															mappable.push(item);
														}
													});
													combo.items = mappable;
												});
											},
											listeners: {
												change: function(event) {
													loadFields(event.target.value, true);
												}
											},
											placeHolder: 'Select'
										},
										{
											tag: 'dl-section-title',
											title: 'Field Rules',
											colspan: 2
										},
										{
											tag: 'dl-toolbar',
											colspan: 2,
											theme: 'spacing',
											children: [
												{
													tag: 'vaadin-button',
													theme: 'primary',
													children: [
														ElementUtil.makeIcon('vaadin:plus', ' Add Field')
													],
													listeners: {
														click: function() {
															var dataType = ElementUtil.query(formPanel, 'dataTypeCB').value;
															loadFields(dataType, false).then(function() {
																actionAddEditFieldRule();
															});
														}
													}
												},
												{
													tag: 'vaadin-button',
													itemid: 'editFieldRule',
													'class': 'spacer-toolbar-item',	
													disabled: true,
													children: [
														ElementUtil.makeIcon('vaadin:edit', ' Edit')
													],
													listeners: {
														click: function() {
															var dataType = ElementUtil.query(formPanel, 'dataTypeCB').value;
															loadFields(dataType, false).then(function() {
																actionAddEditFieldRule(fieldRulesGrid.selectedItems[0]);
															});
														}
													}
												},
												{
													tag: 'vaadin-button',
													itemid: 'removeFieldRule',
													theme: 'error primary',
													disabled: true,
													style: 'float: right;',
													children: [
														ElementUtil.makeIcon('vaadin:trash', ' Remove')
													],
													listeners: {
														click: function() {
															var remaining = [];
															fieldRules.forEach(function(item) {
																if (item !== fieldRulesGrid.selectedItems[0]) {
																	remaining.push(item);
																}
															});
															fieldRules = remaining;
															actionRefreshFieldRules();
														}
													}
												}
											]
										},
										{
											tag: 'vaadin-grid',
											itemid: 'fieldRulesGrid',
											colspan: 2,
											theme: 'row-stripes column-borders',
											style: 'height: 220px;',
											defaults: {
												tag: 'vaadin-grid-sort-column',
												resizable: true
											},
											children: [
												{ path: 'orderId', header: 'Order', width: '5em' },
												{ path: 'dataField', header: 'Data Field', width: '12em' },
												{
													path: 'transforms',
													header: 'Transforms',
													width: '10em',
													renderer: function(root, column, rowData) {
														if (rowData.item.transforms) {
															var labels = [];
															rowData.item.transforms.forEach(function(item) {
																labels.push(item.transform);
															});
															root.innerHTML = labels.join(', ');
														} else {
															root.innerHTML = '';
														}
													}
												}
											],
											postinit: function(gridEl) {
												fieldRulesGrid = gridEl;
												actionRefreshFieldRules();
											},
											listeners: {
												'active-item-changed': function(event) {
													const item = event.detail.value;
													fieldRulesGrid.selectedItems = item ? [item] : [];
													var hasSelection = fieldRulesGrid.selectedItems.length > 0;
													ElementUtil.query(formPanel, 'editFieldRule').disabled = !hasSelection;
													ElementUtil.query(formPanel, 'removeFieldRule').disabled = !hasSelection;
												}
											}
										},
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'div',
											style: 'text-align: center;',
											colspan: 2,
											defaults: {
												tag: 'vaadin-button'
											},
											children: [
												{
													theme: 'primary',
													children: [
														ElementUtil.makeIcon('vaadin:database', ' Save')
													],
													listeners: {
														click: function() {															
															formPanel.submitForm({
																preSubmit: function(data) {
																	data.fieldRules = fieldRules;
																	return data;
																},
																actualCall: function(data) {			
																	if (record) {
																		data.dataTransformRuleSetId = record.dataTransformRuleSetId;
																	}
																	return DataManagementService.getDataTransformRuleSetService().saveDataTransformRuleSet(data, (record ? true : false));
																},
																success: function() {
																	window.DL.MessageUtil.showToast('Success', 'Saved Data Transform Rule Set', {
																		theme: 'success',
																		position: 'top-stretch'
																	});
																	actionRefresh();
																	addEditWin.close();
																}
															});															
														}
													}
												},
												{
													theme: 'tertiary',
													innerHTML: 'Cancel',
													style: 'margin-left: 10px;',
													listeners: {
														click: function() {
															addEditWin.close();
														}
													}
												}
											]
										}
									]
								}
							]
						});			
						
						addEditWin.addToContentElement(formPanel);
						
						if (record) {	
							loadFields(record.dataType, false).then(function() {
								formPanel.load(record);
							});
						}
					}
				}
			});			
		};
		
		var actionDelete = function(record) {
	
			window.DL.MessageUtil.showConfirm({
				title: 'Confirm Delete',
				message: '<b>Are you sure you want to delete "' + record.name + '"?</b> <br><i class="fas fa-exclamation-triangle warning-icon"></i>This config will be removed from associated Integrations.',
				buttons: [
					{
						text: 'Yes',
						handler: function() {
							var loadMask = grid.showLoading('Removing...');

							DataManagementService.getDataTransformRuleSetService().deleteDataTransformRuleSet(record.dataTransformRuleSetId)
							.then(function(){
								loadMask.remove();
								window.DL.MessageUtil.showToast('Success', 'Removed '+ record.name, {									
									theme: 'success'
								});
								actionRefresh();
							});						
						}
					},
					{
						text: 'No'
					}
				]
			});
		};
	}
	
}
customElements.define('dl-data-transform-ruleset-grid', DataTransformRuleSetGrid);
